import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { api, GET, POST, POST_JSON } from "../../ConsumeApiController";


export async function getAttributes()
{
    const response = await GET(CompanyRoutes.Products.Attributes.getAll);

    return response;
}

export async function createAttribute(name)
{
    const response = await POST_JSON(CompanyRoutes.Products.Attributes.create,{
        name
    });

    return response;
}

export async function deleteAttribute(id)
{
    const response = await api.delete(CompanyRoutes.Products.Attributes.delete + id);
    
    return response;
}